import { FC } from "react";
import {
  AddingCriteria,
  AdvancedDeclarationOption,
  EditAllotmentPoliciesLocationValues,
  LocationGrainTrackerValues,
  PrincipalInfoGT,
  QualityCriteriaData,
} from "../../../../../../redux/slices/grainTracker/grainTrackerTypes";
import { LoadingButton } from "@mui/lab";
import { FormControl, MenuItem, Select } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RenderQualityCriteriaInputsToCreate from "./FormRenderQualityCriteriaInputsToCreate";
import { DataSBFilterValues } from "../../../../../../redux/actions/dataTable/DataTableTypes";
import { stylesGW } from "../../../../grainWiseStylesMUIComponents";

type CreateQualityCriteriaInputsParams = {
  t: (arg0: string) => string;
  qualityCriteria: {
    data: QualityCriteriaData[];
    total: number;
    limit: number;
    loading: boolean;
    error: string;
  };
  addingCriteria: AddingCriteria;
  selectedCriteriaV: (values: any) => void;
  setCriteriaToBin: (addingCriteria: AddingCriteria) => void;
  addOptionCriteriaByDefault: QualityCriteriaData[];
  locationGrainTrackerValues: LocationGrainTrackerValues;
  principalInfoGT: PrincipalInfoGT;
  editBins: EditAllotmentPoliciesLocationValues;

  selectedCriteriaTemplate: QualityCriteriaData[];

  resetAddingCriteria: () => void;
  setAdvancedDeclarationOptionText: (
    advancedDeclarationOption: AdvancedDeclarationOption,
    searchText: string,
  ) => void;
  advancedDeclarationOption: AdvancedDeclarationOption;
  setAvancedDeclarationOptionSelected: (values: {
    allValuesSelected: boolean;
    valuesSelected: DataSBFilterValues[];
  }) => void;
  advancedDeclarationOptionSelected: {
    allValuesSelected: boolean;
    valuesSelected: DataSBFilterValues[];
  };
  selectedCriteria: string | undefined;
};

const CreateQualityCriteriaInputs: FC<CreateQualityCriteriaInputsParams> = ({
  t,
  qualityCriteria,
  addingCriteria,
  selectedCriteriaV,
  setCriteriaToBin,
  addOptionCriteriaByDefault,
  locationGrainTrackerValues,
  principalInfoGT,
  editBins,
  selectedCriteria,
  selectedCriteriaTemplate,
  setAdvancedDeclarationOptionText,
  setAvancedDeclarationOptionSelected,
  resetAddingCriteria,
  advancedDeclarationOption,
  advancedDeclarationOptionSelected,
}) => {
  if (qualityCriteria.data.length >= 1) {
    return (
      <div className="graintracker-second-information">
        <div className="form-criteria-GT">
          {addingCriteria.adding ? (
            <FormControl
              sx={
                stylesGW.CreateQualityCriteriaInputs.formCriteriaGTFormControl
              }
            >
              <Select
                required
                onChange={(e) => {
                  selectedCriteriaV(e.target.value);
                  setCriteriaToBin({
                    ...addingCriteria,
                    values: {
                      ...addingCriteria.values,
                      allotmentValueArray: qualityCriteria.data.filter(
                        (values) => values.id === (e.target.value as string),
                      )[0].advancedDeclarationOptionTags as any,
                    },
                  });
                }}
              >
                {addOptionCriteriaByDefault.map((values) => {
                  return (
                    <MenuItem key={values.id} value={values.id}>
                      {values.nameTextId.text}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          ) : (
            ""
          )}

          {/*Input options to select Quality criteria */}

          <RenderQualityCriteriaInputsToCreate
            selectedCriteriaTemplate={selectedCriteriaTemplate}
            t={t}
            addingCriteria={addingCriteria}
            setCriteriaToBin={setCriteriaToBin}
            resetAddingCriteria={resetAddingCriteria}
            setAdvancedDeclarationOptionText={setAdvancedDeclarationOptionText}
            advancedDeclarationOption={advancedDeclarationOption}
            setAvancedDeclarationOptionSelected={
              setAvancedDeclarationOptionSelected
            }
            advancedDeclarationOptionSelected={
              advancedDeclarationOptionSelected
            }
            selectedCriteria={selectedCriteria}
          />
        </div>

        {/*Button to turn on Quality criteria */}

        <LoadingButton
          onClick={() =>
            setCriteriaToBin({
              ...addingCriteria,
              adding: true,
              values: {
                ...addingCriteria.values,
                storageInstanceId: principalInfoGT.id as string,
              },
            })
          }
          sx={{ textTransform: "none" }}
          disabled={addingCriteria.adding}
          startIcon={<AddIcon />}
          loading={locationGrainTrackerValues.loading || editBins.editedLoading}
        >
          {t("Grain_tracker.add-criterion")}
        </LoadingButton>
      </div>
    );
  }
  return "";
};

export default CreateQualityCriteriaInputs;
